<template>
  <!-- Popup Deposit -->
  <el-dialog :title="$t('TEXT_SUCCESS')" :visible.sync="isShowWaitingForm" class="deposit-form waiting-form"
    :close-on-click-modal="false"
    :show-close="false">
    <div class="popup-inner">
      <div class="item">
        <div class="text-break-word bold center">{{ $t('TEXT_PLEASE_WAITING_FOR_LOGIN') }}</div>
        <div class="fix-height-width loading"></div>
      </div>
    </div>
  </el-dialog>
  <!-- End Popup Deposit -->
</template>

<script>
export default {
  computed: {
    isShowWaitingForm: {
      get () {
        return this.$store.getters.isShowWaitingForm
      },
      set () {
        this.$store.dispatch('toggleWaitingForm')
      }
    }
  }
}
</script>
